// extracted by mini-css-extract-plugin
export var option = "_aw-0";
export var optionCard = "_aw-f";
export var optionContent = "_aw-g";
export var optionIcon = "_aw-i";
export var optionIconBox = "_aw-h";
export var optionLabel = "_aw-j";
export var optionPill = "_aw-m";
export var optionPillBadge = "_aw-p";
export var optionPillIcon = "_aw-n";
export var optionPillLabel = "_aw-o";
export var optionRadio = "_aw-k";
export var optionRadioInner = "_aw-l";
export var optionReveal = "_aw-2";
export var optionRevealDelay0 = "_aw-3";
export var optionRevealDelay1 = "_aw-4";
export var optionRevealDelay10 = "_aw-d";
export var optionRevealDelay11 = "_aw-e";
export var optionRevealDelay2 = "_aw-5";
export var optionRevealDelay3 = "_aw-6";
export var optionRevealDelay4 = "_aw-7";
export var optionRevealDelay5 = "_aw-8";
export var optionRevealDelay6 = "_aw-9";
export var optionRevealDelay7 = "_aw-a";
export var optionRevealDelay8 = "_aw-b";
export var optionRevealDelay9 = "_aw-c";
export var optionSelected = "_aw-1";